export const ORCH_CHECKOUT = 'visa.orch.checkout';
export const ORCH_COMPLETE_IDENTITY_VALIDATION = 'visa.orch.complete-identity-validation';
export const ORCH_DELETE_INTENT = 'visa.orch.delete-intent';
export const ORCH_GET_CARD_BINS = 'visa.orch.get-card-bins';
export const ORCH_GET_SRC_PROFILE = 'visa.orch.get-src-profile';
export const ORCH_IDENTITY_LOOKUP = 'visa.orch.identity-lookup';
export const ORCH_INIT = 'visa.orch.init';
export const ORCH_INITIATE_IDENTITY_VALIDATION = 'visa.orch.initiate-identity-validation';
export const ORCH_INO_DECISION = 'visa.orch.ino-decision';
export const ORCH_IS_RECOGNIZED = 'visa.orch.is-recognized';
export const ORCH_OPTIMIZELY_DECISION = 'visa.orch.opt-decision';
export const ORCH_RXO_DECISION = 'visa.orch.rxo-decision';
export const ORCH_RXO_SSIOPTOUT = 'visa.orch.rxo-ssi-opt-out';
export const ORCH_SESSION_TIMEOUT = 'visa.orch.session-timeout';
export const ORCH_TNC_ACCEPTED = 'visa.orch.tnc-accepted';
export const SRC_APP_TRANSITIONING = 'visa.src.app-transitioning';
export const SYS_SESSION_RENEW = 'visa.src.session-renew';
export const SYS_SESSION_START = 'visa.src.session-start';
export const SYS_SIGN_OUT = 'src:sys-shell:sign-out';
export const VSB_CANCEL = 'visa.vsb.cancel';
export const VSB_COMPLETE = 'visa.vsb.complete';
export const VSB_ERROR = 'visa.vsb.error';
